import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {EventHandler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DateTimeFormatsEnum} from '../../../../../srcCommon/formatters/dateTime/dateTimeFormatter';
import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {LocalPreferencesFlagsEnum} from '../../../../models/api/localPreferencesModel';
import {toggleFlagAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {getFlags} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {InteractiveDateTimeFormatter} from './interactiveDateTimeFormatter';

/*
 * Selectors.
 */

const getDateTimeFormat = createSelector(getFlags, (flags) =>
  flags[LocalPreferencesFlagsEnum.ABSOLUTE_DATETIME]
    ? DateTimeFormatsEnum.ABSOLUTE
    : DateTimeFormatsEnum.RELATIVE,
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  format: getDateTimeFormat,
}));

export const InteractiveDateTimeFormatterContainer = connect(
  mapStateToProps,
  {toggleFlagAction},
  (stateProps, dispatchProps, ownProps) => {
    // Build the method to toggle the expanded state.
    const onClick: EventHandler = (e) => {
      e.preventDefault();
      e.stopPropagation();
      dispatchProps.toggleFlagAction(LocalPreferencesFlagsEnum.ABSOLUTE_DATETIME);
    };

    // Merge the props.
    return {
      ...stateProps,
      ...ownProps,
      onClick,
    };
  },
)(InteractiveDateTimeFormatter);
